import { httpApi } from "./http.api";

export const getAllCataProducts = (currentPage: any, data: any): Promise<any> =>
  httpApi
    .get<any>(`catalog_product?page=${currentPage}`, { params: data })
    // .get<any>(`products?page=1&search=`)
    .then(({ data }: any) => data);

export const getCustomizeProducts = (
  currentPage: any,
  data: any
): Promise<any> =>
  httpApi
    .get<any>(`customized_products?page=${currentPage}`, { params: data })
    // .get<any>(`products?page=1&search=`)
    .then(({ data }: any) => data);

export const getCustomizeProducts_pod = (
  currentPage: any,
  data: any
): Promise<any> =>
  httpApi
    .get<any>(`customized_products/podAll?page=${currentPage}`, {
      params: data,
    })
    // .get<any>(`products?page=1&search=`)
    .then(({ data }: any) => data);

export const getFilteredProducts = (
  currentPage: any,
  productSet: string = 'kodiak',
  data: any = {}
): Promise<any> =>
  httpApi
    .get<any>(`front-design/filtered/${productSet}?page=${currentPage}`, {
      params: data,
    })
    .then(({ data }: any) => data);

export const getCataProduct = (id: any): Promise<any> =>
  httpApi.get<any>(`front-design/pod/${id}`);

export const getCustomizedProduct = (id: any): Promise<any> =>
  httpApi.get<any>(`front-design/customize_products/pod/${id}`);

export const getCustomizedProductTable = (id: any): Promise<any> =>
  httpApi.get<any>(`front-design/pod/table/${id}`);

export const getCatalogProductOptionsValues = (id: any): Promise<any> =>
  httpApi.get<any>(`catalog_product_option_value/${id}`);

export const getCatalogOptionsValues = (id: any): Promise<any> =>
  httpApi.get<any>(`catalog_option_values/${id}`);

export const getCatalogProductOptions = (id: any): Promise<any> =>
  httpApi.get<any>(`front-design/pod/by_id/${id}`);

export const getCataProductVariants = (id: any): Promise<any> =>
  httpApi
    .get<any>(`catalog-product-variants/${id}`)
    .then(({ data }: any) => data);

export const getCataProductImages = (id: any): Promise<any> =>
  httpApi
    .get<any>(`front-design/product-images/${id}`)
    .then(({ data }: any) => data);
